import PropTypes from 'prop-types'
import { Component, createRef } from 'react'

import { withDiscardDialog } from '../../../../lib/global-discard-dialog'
import * as Card from '../../../shared/card'
import MagicGrid from '../../../shared/MagicGrid'

import { igaoHeader, patientHeader } from './GridHeaders'
import IssueFilters from './IssueFilters'
import IssueFormWrapper from './IssueFormWrapper'

const rememberSortParams = d => d

const displayRowFn = row => {
  const styleClasses = []
  if (row.modified) {
    styleClasses.push('nh-modified-issue')
  }

  return styleClasses
}

@withDiscardDialog
class IgaoComponent extends Component {
  constructor (props) {
    super(props)
    this.state = {}
    this.cancelCollapseForm = this.cancelCollapseForm.bind(this)
    this.saveCollapseForm = this.saveCollapseForm.bind(this)
    this.cancelForm = this.cancelForm.bind(this)

    this.magicGrid = createRef()
  }

  cancelCollapseForm (index) {
    // TODO: get this key
    this.props.discardDialog.show('igao', () => this.magicGrid.current?.collapse(index))
  }

  cancelForm (index) {
    this.magicGrid.current?.collapse(index)
  }

  saveCollapseForm (data, index) {
    const { onSave } = this.props
    onSave(data)
    this.magicGrid?.current?.collapse(index)
  }

  render () {
    const { rows, filters, currentUser, issueCounts, updateFilters } =
      this.props
    return (
      <div className='main'>
        <Card.Card>
          <Card.Header>
            <h2>Issues | Goals | Actions | Outcomes</h2>
          </Card.Header>
          <div style={{ padding: '1rem' }}>
            <IssueFilters
              onChange={updateFilters}
              activeFilters={filters}
              issues={rows}
              counts={issueCounts}
            />
            <MagicGrid
              rows={rows}
              canDelete={false}
              itemName='Issues'
              onSort={data => rememberSortParams(data)}
              headers={igaoHeader}
              expansionComponent={IssueFormWrapper}
              collapseRowFn={this.cancelCollapseForm}
              expansionComponentProps={({ index }) => ({
                onCancel: this.cancelForm,
                onSave: this.saveCollapseForm,
                currentUser,
                formKey: `igao-${index}`
              })}
              ref={this.magicGrid}
              displayRowFn={displayRowFn}
              sortOn={8}
            />
          </div>
        </Card.Card>
      </div>
    )
  }
}

IgaoComponent.propTypes = {
  updateFilters: PropTypes.func.isRequired,
  rows: PropTypes.instanceOf(Array).isRequired,
  onSave: PropTypes.func.isRequired,
  currentUser: PropTypes.instanceOf(Object),
  issueCounts: PropTypes.instanceOf(Object)
}

function PatientFolderComponent ({ rows }) {
  return (
    <div className='main'>
      <MagicGrid
        rows={rows}
        canDelete={false}
        itemName='issues'
        onSort={data => rememberSortParams(data)}
        headers={patientHeader}
        sortOn={6}
        disableGrid
      />
    </div>
  )
}

PatientFolderComponent.propTypes = {
  rows: PropTypes.instanceOf(Array).isRequired
}

export { IgaoComponent, PatientFolderComponent }
